var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPlayActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_play") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "19_Specific-club---matches",
    transform: "translate(-371, -748)",
    fill: "#BFE82D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(351, 734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_play",
    transform: "translate(20, 14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C12.4182559,0 16,3.58171797 16,8 C16,12.418227 12.418227,16 8,16 C3.58171797,16 0,12.4182559 0,8 C0,3.58168904 3.58168904,0 8,0 Z M8,0.879763179 C4.06761499,0.879763179 0.879763179,4.06761499 0.879763179,8 C0.879763179,11.932385 4.06761499,15.1202368 8,15.1202368 C11.9324141,15.1202368 15.1202368,11.9324399 15.1202368,8 C15.1202368,4.06758591 11.9324399,0.879763179 8,0.879763179 Z M6.47855388,4.65075266 L10.8072474,7.53652033 C11.1380404,7.75704898 11.1380404,8.243035 10.8072474,8.46356365 L6.47855388,11.3494153 C6.1083748,11.5962293 5.61247927,11.330772 5.61247927,10.8858517 L5.61247927,5.11423233 C5.61247927,4.669312 6.1083748,4.40393861 6.47855388,4.65075266 Z M6.4083475,5.56032836 L6.4083475,10.4397556 L10.067897,8 L6.4083475,5.56032836 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlayActive);
export default __webpack_public_path__ + "static/media/ic_play_active.24d0a3533f6ccd60e614bba9ca765746.svg";
export { ForwardRef as ReactComponent };